import { FormattedMessage } from 'react-intl';

import { useCommon } from '../../context/CommonContext';
import { useLocale } from '../../context/LocaleContext';
import Heading from '../Heading/Heading.styled';
import Popup from '../Popup/Popup';
import { FaqWrapperStyled, MainTitleStyled, QuestionListStyled } from './FaqPopup.styled';
import useFaq from './hooks/useFaqPopup';

type FaqPopupPropsT = {
  isOpen: boolean;
  onClose: () => void;
};

const FaqPopup: React.FC<FaqPopupPropsT> = ({ isOpen, onClose }) => {
  const { customerId, isMuralToTheme } = useCommon();
  const { selectedLocale } = useLocale();
  const { faqData } = useFaq(customerId);

  return (
    <Popup isOpen={isOpen} isTopButton={true} onClose={onClose}>
      <FaqWrapperStyled>
        <MainTitleStyled level={1}>
          <FormattedMessage id="button.FAQ" defaultMessage="FAQ" />
        </MainTitleStyled>

        <QuestionListStyled isMuralToTheme={isMuralToTheme}>
          {faqData?.length &&
            faqData.map(({ id, answer, question }) => {
              return (
                <li key={id}>
                  <Heading level={2}>{question[selectedLocale]}</Heading>
                  <p dangerouslySetInnerHTML={{ __html: answer[selectedLocale] }}></p>
                </li>
              );
            })}
        </QuestionListStyled>
        <p>
          <FormattedMessage
              id="faq.info"
              defaultMessage="Didn’t find an answer to your question or have a suggestion? Contact <a>Wayaj</a>."
              values={{
                a: chunk => <a href="mailto:hello@wayaj.com">{chunk}</a>,
              }}
          />
        </p>
      </FaqWrapperStyled>
    </Popup>
  );
};

export default FaqPopup;
